const WHITE = '#FFF';
const BLACK = '#000';
const GREEN_LIGHT = '#16C4AB';
const GREEN_SUCCESS = '#68c153';
const ORANGE = '#F45530';
const ORANGE_LIGHT = '#EDA698';
const RED = '#d61f07';
const RED_FAILURE = "#b72e2e";
const TABLE_LIGHT_GREY = '#302e30';
const TABLE_DARK_GREY = '#202020';
const TURQUOISE = '#ace5db';

export {
  WHITE,
  BLACK,
  GREEN_LIGHT,
  GREEN_SUCCESS,
  ORANGE,
  ORANGE_LIGHT,
  RED,
  RED_FAILURE, 
  TABLE_LIGHT_GREY,
  TABLE_DARK_GREY, 
  TURQUOISE
}